import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { FreeLayout, MainLayout } from './layouts';
import { adminRoute, privateAdminRoutes, publicAdminRoutes } from './utils/routes/admin';
import { publicRoutes } from './utils/routes';
import { PrivateRoute } from './components/common';

type Props = {};

const App = (props: Props) => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path={'/'} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>
        <Route path={adminRoute.base} element={<Navigate to={`${adminRoute.base}${adminRoute.login}`} />}></Route>

        <Route element={<FreeLayout />}>
          {publicRoutes.map((route, index) => {
            const Page = route.component || '';
            return (
              <Route key={index} path={route.path} element={<Page />}>
                {route.children &&
                  route.children.length > 0 &&
                  route.children.map((childRoute, index) => {
                    const ChildComponent = childRoute.component;
                    return (
                      <Route
                        key={index}
                        path={childRoute.path}
                        index={childRoute.index ?? false}
                        element={<ChildComponent />}
                      />
                    );
                  })}
              </Route>
            );
          })}
        </Route>

        <Route element={<PrivateRoute redirectTo={`${adminRoute.base}${adminRoute.login}`} />}>
          <Route path={adminRoute.base} element={<MainLayout />}>
            {privateAdminRoutes.map((route, index) => {
              const Page = route.component || '';
              return (
                <Route key={index} path={route.path} element={<Page />}>
                  {route.children &&
                    route.children.length > 0 &&
                    route.children.map((childRoute, index) => {
                      const ChildComponent = childRoute.component;
                      return (
                        <Route
                          key={index}
                          path={childRoute.path}
                          index={childRoute.index ?? false}
                          element={<ChildComponent />}
                        />
                      );
                    })}
                </Route>
              );
            })}
          </Route>
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default App;
